export default __webpack_public_path__ + "static/media/usdc_eth.a2bc0748.svg";